import React, { useCallback, useState } from 'react';
import { useTranslation } from "react-i18next";
import ButtonFilled from "../../../../../components/FormElements/ButtonFilled";
import transactionsApi from "../../../../../store/transactionsStore/transactionsApi";
import { PhoneInputField } from "../../../../../components/PhoneInput";
import styles from './form.module.scss';

const Form = ({
  info,
  phone,
  setPhone,
  setError,
  setUser,
  setCurrentForm,
  certificate,
  certificates,
  setCertificate,
}) => {
  const { t } = useTranslation();
  const [searching, setSearching] = useState(false);

  const searchingUser = useCallback(() => {
    if (!info || !info.id) return setSearching(false)
    new Promise((resolve, reject) => {
      transactionsApi.getUserInfo('phone', phone.replace(/\D/g, ''), info.id)
        .then((res) => {
          const user = res.data;
          resolve({user});
        })
        .catch((e) => {
          reject(e);
        })
    })
      .then(({user}) => {
        setUser(user);
        setSearching(false);
        setCurrentForm(2);
      })
      .catch(() => {
        setSearching(false);
        setCurrentForm(3);
      });
  }, [phone, info]);

  const onPhoneChange = (value) => {
    setError(false);
    setPhone(value);
  }

  const findUser = (e) => {
    e.preventDefault();

    setSearching(true);
    searchingUser();
  }

  return (
    <form onSubmit={findUser} className={styles.container}>
      <p className={styles.title}>{certificate?.header} {certificate?.bonus_amount}</p>
      <div style={{ marginBottom: 15, zIndex: 20 }}>
        <PhoneInputField
          placeholder={t('NSAssessment.phone')}
          dropdownStyle={{ borderRadius: 0 }}
          value={phone}
          onChange={onPhoneChange}
          disabled={false}
          error={false}
        />
      </div>
      <p style={{ fontWeight: 600, marginBottom: 0, marginTop: 20 }}>{t('Certificate.chooseCertificate')}</p>
      <div className={styles.certificates}>
        {certificates.map((item, index) => (
          <div className={`${styles.certificate} ${certificate?.id === item.id ? styles.active : ''}`} key={item.id} onClick={() => setCertificate(item)}>
            {item.header} {item.bonus_amount}
          </div>
        ))}
      </div>

      <ButtonFilled
        type="submit"
        className={styles.btn}
        loading={searching}
        disabled={searching || !certificates.length || !certificate?.id}
      >{t('Certificate.sendCertificate')}</ButtonFilled>
    </form>
  )
}

export default Form